import { render, staticRenderFns } from "./Stockholders.vue?vue&type=template&id=16e55bd9&scoped=true"
import script from "./Stockholders.vue?vue&type=script&lang=js"
export * from "./Stockholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e55bd9",
  null
  
)

export default component.exports